<template v-if="data">
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Movement Strategy" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New Movement Strategy</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/5 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Template Name *" v-model="data.name"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-3/5 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Template Description *" v-model="data.description"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/5 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Type</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="data.type"
                                    width="100%"
                                    autocomplete
                                    @input="typeChange"
                                >
                                    <vs-select-item v-for="(item, index) in typeOptions" :key="index" :value="item.value" :text="item.text"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
            <vs-card class="p-4 mb-6">
                <vs-list>
                    <draggable :list="strategyOptions" class="cursor-move">
                            <vs-list-item class="flex items-center p-1 list-item pt-10 pb-10" v-for="(item, index) in strategyOptions" :key="index" :title="item.name" :subtitle="item.description">
                                    <vs-checkbox v-model="item.enable" v-if="checkboxReady">Enable</vs-checkbox>
                            </vs-list-item>
                    </draggable>
                </vs-list>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
    import draggable from 'vuedraggable'

	export default {
		components:{
            vSelect,
            draggable
		},
		data(){
			return {
                isLoading: false,
                detailsCount: 0,
                data: {
                    name: '',
                    description: '',
                    type: 'Pick'
                },
                pickOptions: [],
                putOptions: [],
                typeOptions: [
                    {
                        value: 'Pick',
                        text: 'Pick'
                    },
                    {
                        value: 'Put',
                        text: 'Put'
                    }
                ],
                strategyOptions: [],
                checkboxReady: false,
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            },
            strategyOptions: function() {
                this.checkboxReady = false
                this.$nextTick(() => {
                    this.checkboxReady = true
                })
            }
        },
        methods:{
            fetchData(api) {
                return this.$http.get(api)
            },
            submitForm() {
                this.isLoading = true
                const details = []

                this.strategyOptions.map((item, index) => {
                    details.push({
                        no_priority: index + 1,
                        msl_id: item.id,
                        enable: item.enable ? 1 : 0,
                    })
                })

                const data = {
                    movement_strategy: {
                        name: this.data.name,
                        description: this.data.description,
                        type: this.data.type,
                    },
                    details: details
                }

                this.$http.post('master/movementstrategy/store', data)
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully.'
                    })
                    this.$router.push({ name: 'master-movement-strategy' })
                })
                .catch(error => this.handleError(error))
            },
            back() {
                if(this.data.name != '' || this.data.description != '') {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.push({name: 'master-movement-strategy'}),
                    })
                }
                else{
                    this.$router.push({name: 'master-movement-strategy'})
                }
            },
            fetchAllData() {
                this.isLoading = true
                Promise.all([this.$http.get('master/movementstrategylist/pick'), this.$http.get('master/movementstrategylist/put')])
                .then(this.$http.spread((pick, put) => {
                    this.pickOptions = pick.data
                    this.putOptions = put.data
                    this.strategyOptions = pick.data

                    this.pickOptions.map(item => {
                        item.enable = true
                    })

                    this.putOptions.map(item => {
                        item.enable = true
                    })

                    this.data.type = 'Pick'

                    this.isLoading = false
                }))
                .catch(() => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.fetchAllData()
                        },
                        cancel: () => this.$router.push({name: 'master-movement-strategy'}),
                        acceptText: 'Yes',
                        cancelText: 'No'
                    })
                })
            },
            typeChange() {
                if(this.data.type == 'Pick') {
                    this.strategyOptions = this.pickOptions
                }
                else {
                    this.strategyOptions = this.putOptions
                }
            },
            reset() {
                this.strategyOptions.map(item => {
                    if(item.id == 1) {
                        item.enable = false
                    }
                })
            }
        },
        mounted(){
            this.fetchAllData()
        },
	}
</script>
<style>
.list-item {
  transition: all 1s
}
</style>